import { dataProps } from './properties'

export const setTaxSetting = (state, payload) => {
    state.props = []
    let key = 0
    payload.forEach(element => {
        element.key = key
        state.props.push(element)
        key ++
    })
    if(payload.length === 0) {
        state.props.push(JSON.parse(JSON.stringify(dataProps)))
    }
    
}

export const addNewTaxSettingRow = state => {

    let key = 0
    state.props.push(JSON.parse(JSON.stringify(dataProps)))

    state.props.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('tax_name_'+(key-1)).focus()
    }, 300);

}

export const removeTaxSettingRow = (state, payload) => {

    let key = 0

    state.deletedItems.push(state.props[payload])

    state.props.splice(payload, 1)

    state.props.forEach(element => {
        element.key = key
        key ++
    })

}


// WEBPACK FOOTER //
// ./src/store/modules/taxSetting/mutations.js